// ════════════════════════════════════════════════════════════════════
// Glass-i — Stage SCAN-2 · Tenant scanner fleet API client.
// Base: /api/erp/production/scan-devices
//
//   list        → { items, departments: [{departmentCode, entry, exit, health}],
//                   unassignedCount }
//   departments → dropdown feed (main stages AND Manual/Machine sub-stations)
//   patch       → MASTER ONLY. Assign a department + entry/exit role, rename,
//                 or switch a scanner off.
//
// There is deliberately no allocate / rotate-key / retire here. Those are
// Glass-i operations on /api/internal/scan-devices, and the backend enforces
// it with a field allowlist rather than merely omitting the routes.
// ════════════════════════════════════════════════════════════════════

import client from '../../../../api/client';

const BASE = '/api/erp/production/scan-devices';

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : (resp ? resp.data : null);
}
const enc = encodeURIComponent;

export const scanDevicesApi = {
  list: () => client.get(BASE).then(unwrap),
  departments: () => client.get(`${BASE}/departments`).then(unwrap),
  get: (id) => client.get(`${BASE}/${enc(id)}`).then(unwrap),
  // patch keys are limited to: departmentCode, scanRole, displayName,
  // locationNote, operatorUserId, repeatWindowSec, isActive.
  patch: (id, body) => client.patch(`${BASE}/${enc(id)}`, body).then(unwrap)
};

export default scanDevicesApi;
